import { AfterContentChecked, Component, Input, inject } from '@angular/core';
import { AccountType, BankingDetails } from '../../../../_interfaces/business.interface';
import { InfoBlockComponent } from '../../../../shared/components/info-card-block/info-block.component';
import { OffcanvasService } from '../../../../_services/offcanvas-service/offcanvas.service';

interface BankFields {
  label: string;
  value?: string | number;
  placeholder: string;
  is_proof?: boolean;
}
@Component({
  selector: 'app-banking-details-body',
  imports: [InfoBlockComponent],
  templateUrl: './banking-details.component.html',
})
export class BankingDetailsComponent implements AfterContentChecked {
  readonly offcanvasService = inject(OffcanvasService);

  @Input({ required: true }) bankingDetails: BankingDetails | null | undefined;
  bankFields: BankFields[] = [
    {
      label: 'Bank',
      placeholder: 'Add bank',
    },
    {
      label: 'Branch code',
      placeholder: 'Add branch code',
    },
    {
      label: 'Account number',
      placeholder: 'Add account number',
    },
    {
      label: 'Account holder',
      placeholder: 'Add account holder',
    },
    {
      label: 'Account type',
      placeholder: 'Add account type',
    },
    {
      label: 'Proof of banking details',
      placeholder: 'Add proof of banking details',
      is_proof: true,
    },
  ];
  generated = false;

  ngAfterContentChecked() {
    if (!this.generated && this.bankingDetails) {
      this.generateBankFields(this.bankingDetails);
    }
  }

  generateBankFields(res: BankingDetails) {
    this.bankFields.forEach((field) => {
      if (field.label === 'Bank') field.value = res.bank;
      if (field.label === 'Branch code') field.value = res.branch_code;
      if (field.label === 'Account number') field.value = res.account_number;
      if (field.label === 'Account holder') field.value = res.account_holder;
      if (field.label === 'Account type') field.value = AccountType[res?.account_type];
      if (field.label === 'Proof of banking details')
        field.value = res?.proof_download_url ? 'bank_confirmation.pdf' : 'N/A';
    });
    // stop ngAfterContentChecked from continuously running
    this.generated = true;
  }

  onEditBankingDetails() {
    this.offcanvasService.offCanvasNavigate(`/settings/edit-banking-details/`);
  }
}
